export async function tryCatch<T>(
  promise: Promise<T>,
): Promise<{ data: T; error: null } | { data: null; error: Error }> {
  try {
    const data = await promise
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error as Error }
  }
}
